import React from 'react';
import LoginContainer from 'app/containers/Admin/LoginContainer';

const UserLoginPage = () => (
    <div className="user-login-page">
        <LoginContainer isAdmin={false}/>
    </div>
);

export default UserLoginPage;